import { Overlay, Modal, Button, Dropdown, Popover, Collapse } from 'react-bootstrap';
import { useState, useRef } from 'react';

/*조작법 설명*/ 
function QuestionModal({ show, handleClose, showHint }) {
  const [open, setOpen] = useState(false); // Collapse용

  const [showexamplePopover, setShowexamplePopover] = useState(false);
  const [examplePopoverText, setexamplePopoverText] = useState('');
  const exampleRef = useRef(null);

  const handleexampleClick = () => {
  setexamplePopoverText("이런 식으로,");
  setShowexamplePopover(true);
  setTimeout(() => setShowexamplePopover(false), 2000);
};

  const [showShadowPopover, setShowShadowPopover] = useState(false);
  const [ShadowPopoverText, setShadowPopoverText] = useState('');
  const ShadowRef = useRef(null);

  const handleShadowClick = () => {
  setShadowPopoverText("그림자 속에서도 단서를 얻을 수 있고,");
  setShowShadowPopover(true);
  setTimeout(() => setShowShadowPopover(false), 2000);
};


  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} fullscreen>
      <Modal.Header closeButton>
        <Modal.Title>도움말</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>클릭할 수 있는 <strong>모든 곳</strong>을 클릭해보세요</p>

        {/* ✅ Dropdown 예시 */}
        <p className="mt-4">어떤 건</p>
        <Dropdown>
          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
            클릭했을 때
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1">이런 식으로</Dropdown.Item>
            <Dropdown.Item href="#/action-2">단서를 얻을 수도</Dropdown.Item>
            <Dropdown.Item href="#/action-3">있고</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* ✅ Popover 예시 */}
        <p className="mt-4">또 어떤 건</p>
        <div className="d-flex" style={{ gap: '0px' }}>
        <button
          ref={exampleRef}
          type="button"
          className="btn btn-success"
          onClick={handleexampleClick}
          style={{
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0',
          }}
        >클릭했을 때</button>

        <button
          ref={ShadowRef}
          type="button"
          className="btn btn-dark"
          onClick={handleShadowClick}
          style={{
            borderTopLeftRadius: '0',
            borderBottomLeftRadius: '0',
            padding: 3,
          }}
        >
        <span style={{ width: '100%', height: '100%' }}></span>
        </button>

        </div>
        
        {exampleRef.current && (
          <Overlay target={exampleRef.current} show={showexamplePopover} placement="right">
            {(props) => (
              <Popover {...props}>
                <Popover.Body>{examplePopoverText}</Popover.Body>
              </Popover>
            )}
          </Overlay>
        )}

        {ShadowRef.current && (
          <Overlay target={ShadowRef.current} show={showShadowPopover} placement="top">
            {(props) => (
              <Popover {...props}>
                <Popover.Body>{ShadowPopoverText}</Popover.Body>
              </Popover>
            )}
          </Overlay>
        )}




        {/* ✅ Collapse 예시 */}
        <p className="mt-4">그리고 어떤 건</p>
        <Button
          onClick={() => setOpen(!open)}
          aria-controls="collapse-text"
          aria-expanded={open}
          variant="warning"
          className="mb-2"
        >
          {open ? '닫고 싶을 때' : '클릭했을 때'}
        </Button>
        <Collapse in={open}>
          <div id="collapse-text">
            <div className="p-3 border rounded bg-light">
              이런 식으로 단서를 얻을 수도 있습니다
            </div>
          </div>
        </Collapse>
        
        <p className="mt-4">마지막으로</p>
        <Button
              variant="info"
              className="mt-3"
              onClick={() => {alert('클릭할 수 있는 모든 곳을 클릭해보셔야 합니다');}}
            >
              잊지 마세요
        </Button>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex gap-2 mb-2 justify-content-end">
        {showHint && (
          <Button
              variant="outline-secondary"
              onClick={() => {alert('편지의 내용이 수상하다. 서랍들의 내용물도... 그리고 주변을 잘 살펴보자');}}
            >
              HINT
        </Button>
        )}
        <Button variant="primary" onClick={handleClose}>
          확인
        </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default QuestionModal;
